import { generateLabelsAndValues } from "../utils/HelperFunctions";
export const RENEWAL_STATUS = {
    PENDING : 1,
    APPROVED : 2,
    REJECTED : 3,
  }

export const RENEWAL_STATUS_TAB = [
    {
      name: "Pending",
      type: RENEWAL_STATUS.PENDING,
    },
    {
      name: "Approved",
      type: RENEWAL_STATUS.APPROVED,
    },
  ];
  
  export const PROFILE_INFORMATION = {
    BASIC_INFORMATION: 1,
    CPD_HOURS: 2,
  };

  export const PROFILE_INFORMATION_TABS = [
    {
      name: "Basic Information",
      type: PROFILE_INFORMATION.BASIC_INFORMATION,
    },
    {
      name: "CPD Hours",
      type: PROFILE_INFORMATION.CPD_HOURS,
    },
  ];

  export const PreferredRegistration = {
    PROFESSIONAL_TECHNOLOGIST: 3,
    CERTIFIED_TECHNICIAN: 4,
  };
  
  export const CertificateTypeStrings = {
    [PreferredRegistration.PROFESSIONAL_TECHNOLOGIST]: 'Professional Technologist',
    [PreferredRegistration.CERTIFIED_TECHNICIAN]: 'Certified Technician',
  };

  export const CPDStatus = {
    PENDING : 1,
    APPROVED : 2,
    REJECTED : 3,
    DELETED : 4,
  }
  export const CpdStatusType = generateLabelsAndValues(CPDStatus);